module.exports = "/_next/static/images/megha-a5c26643893455cea03c037e90a34084.png";